import { CabButton } from "@CabComponents/CabButton";
import { CabModal } from "@CabComponents/CabModal";
import { ReactElement } from "react";
import AttendeeList from "../ScheduleShareModal/AttendeeList";
import {
  Leader, MeetingLeader, MeetingLeaderUpdate, OrganizationLeader, ParticipantAutocompleteOption,
  PrivateExternalParticipant, PrivateExternalParticipantCreate, PrivateExternalParticipantUpdate,
} from "../../../store";


export type EditParticipantsModalProps = {
  open: boolean;
  onClose: () => void;
  meetingIsSaved: boolean;
  meetingIsPoll: boolean;
  participants?: PrivateExternalParticipant[];
  meetingLeaders: MeetingLeader[];
  onAddLeader: (id: number) => void;
  onUpdateLeader: (leader: MeetingLeaderUpdate, leaderId: number) => Promise<void>;
  onRemoveLeader: (meetingLeaderId: number) => void;
  addLeaderOptions: Leader[];
  orgLeaders: OrganizationLeader[];
  participantAutoCompleteOptions: ParticipantAutocompleteOption[];
  onAddParticipants: (participants: Omit<PrivateExternalParticipantCreate, 'meeting'>[]) => Promise<void>;
  onUpdateParticipant: (participant: PrivateExternalParticipantUpdate) => Promise<void>;
  onDeleteParticipant: (id: number) => void;
  onFetchAutocompleteOptions: (s: string) => Promise<void>;
  onHideAutocompleteContact?: (contact: ParticipantAutocompleteOption) => Promise<void>;
  onInviteOrgLeader: (leaderId: number) => Promise<void>;
  meetingPreventConflicts?: boolean;
};



const EditParticipantsModal = ({ 
  open, onClose, meetingIsSaved, meetingIsPoll, participants, meetingLeaders, participantAutoCompleteOptions,
  onRemoveLeader, onAddLeader, onUpdateLeader, addLeaderOptions, orgLeaders, meetingPreventConflicts,
  onAddParticipants, onDeleteParticipant, onUpdateParticipant, onFetchAutocompleteOptions, onHideAutocompleteContact,
  onInviteOrgLeader,
}: EditParticipantsModalProps): ReactElement => {
  return (
    <CabModal
      open={open}
      onClose={onClose}
      title="Participants"
      closeIcon
      closeOnBackdropClick
      actionButtons={
        <CabButton buttonType="primary" onClick={() => onClose()}>
          Done
        </CabButton>
      }
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: 520,
        },
      }}
    >
      <AttendeeList
        attendees={participants || []}
        onDeleteAttendee={onDeleteParticipant}
        onAddAttendees={onAddParticipants}
        onUpdateAttendee={onUpdateParticipant}
        participantAutocompleteOptions={participantAutoCompleteOptions}
        fetchAutocompleteOptions={onFetchAutocompleteOptions}
        onHideAutocompleteContact={onHideAutocompleteContact}
        isMdDown={false}
        hasAttendeeListOptions={true}
        meetingLeaders={meetingLeaders}
        onRemoveLeader={onRemoveLeader}
        onAddLeader={onAddLeader}
        onUpdateLeader={onUpdateLeader}
        leaders={addLeaderOptions}
        orgLeaders={orgLeaders}
        onInviteOrgLeader={onInviteOrgLeader}
        isAdditionalParticipantModal
        // disableAdditionalParticipantsMessage={meetingIsSaved
        //   ? undefined
        //   : 'Additional participants can be added once the meeting has been saved'}
        meetingPreventConflicts={meetingPreventConflicts}
        meetingIsSaved={meetingIsSaved}
        meetingIsPoll={meetingIsPoll}
      />
    </CabModal>
  );
};

export default EditParticipantsModal;
